import { BoxEventDisplays, EventType } from "../../../../../enums/eventType";
import { AcsEventNameDisplay, AcsEventName } from "../../../../../enums/acsEventName";
import { ManagementEventNameDisplay, ManagementEventName } from "../../../../../enums/managementEventName";
import { RoomStatusAlarmNameDisplay, RoomStatusAlarmName } from "../../../../../enums/roomStatusAlarmName";
import { SystemErrorNameDisplay, SystemErrorName } from "../../../../../enums/systemErrorName";
import { EventTypeOption } from "../../../events/ManagementEventOptions";

export const BOX_EVENT_TYPE_OPTIONS = Array.from(BoxEventDisplays);

export const EVENT_TYPE_NAME_OPTIONS: EventTypeOption[] = BOX_EVENT_TYPE_OPTIONS.map((eventType): EventTypeOption => {
    return {
        value: eventType[0],
        label: eventType[1],
        eventNames: getEventNameOptions(eventType[0]).map((eventName) => {
            return { value: eventName[0], label: eventName[1] };
        })
    };
});

export function getEventNameOptions(eventType: number | null): [number, string][] {
    switch (eventType) {
        case EventType.SystemError:
            return Array.from(SystemErrorNameDisplay).filter(([key]) => [SystemErrorName.inconsistentBox].includes(key)
            );
        case EventType.AcsEvent:
            return Array.from(AcsEventNameDisplay).filter(([key]) => [AcsEventName.BoxStatusChanged].includes(key)
            );
        case EventType.RoomStatusAlarm:
            return Array.from(RoomStatusAlarmNameDisplay).filter(([key]) => [
                RoomStatusAlarmName.UnauthorizedBoxOpening,
                RoomStatusAlarmName.BoxLeftOpen,
            ].includes(key)
            );
        case EventType.ManagementEvent:
            return Array.from(ManagementEventNameDisplay).filter(([key]) => [
                ManagementEventName.LeaseCreated,
                ManagementEventName.LeaseEdited,
                ManagementEventName.LeaseRemoved,
                ManagementEventName.BoxCreated,
                ManagementEventName.BoxDeleted,
            ].includes(key)
            );
        default:
            return [];
    }
}
